var map = {
	"./en-AU.json": 3945,
	"./en-CA.json": 5807,
	"./en-NZ.json": 4395,
	"./en-SG.json": 5821,
	"./en-US.json": 2607,
	"./en.json": 8464,
	"./fr-CA.json": 2250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;